<template>
  <v-app style="margin-top:0px;" >
      <v-card flat style=" background-image: linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url('https://images.pexels.com/photos/258117/pexels-photo-258117.jpeg?auto=compress&cs=tinysrgb&w=1600')" class="tst">
          <v-container>
              <h1 class="res" style="margin-top:20px;">{{ title }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
            <h2 class="country-heading m-2 " > {{ title }}</h2>
          <div class="col-lg-12 col-md-12  col-sm-12" style="margin-top:10px; ">
            <img class="img-fluid" :src="src" style="width: 60%;" />
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 " v-html="description" style="color:grey;" >
          </div>
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525">University of Hertfordshire</h5>
               <h5 style="margin-bottom:20px;color:#f12525">University of Leicester</h5>
               <h5 style="margin-bottom:20px;color:#f12525">Algoma University</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >University  <span style="font-weight:600">News</span></h2>
              </div>
            <v-card  elevation="10" style="background-image: url('https://www.worldwin.co.in/img/UH.ce4f0336.jpeg');" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 70px;"> University of Hertfordshire</h4>
              </div>
            </v-card>

          </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "./../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],

      src: sessionStorage.getItem("unisrc"),
      title: sessionStorage.getItem("unititle"),
      description: sessionStorage.getItem("unidescription"),
      

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: ['IELTS', 'TOEFL', 'GRE', 'SAT', 'GMAT'],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName,
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'University Details',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }

            let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              comment: comment,
              pageName: 'University Details',
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: "Website",
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        }
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      /* } else {
        this.$toaster.error(`Required field are empty!!`);
      } */
    },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 140px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
